import { render, staticRenderFns } from "./ProductsViewError.vue?vue&type=template&id=0c40c20a&scoped=true"
import script from "./ProductsViewError.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProductsViewError.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./ProductsViewError.vue?vue&type=style&index=0&id=0c40c20a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c40c20a",
  null
  
)

export default component.exports